<div class="flex gap-4">
  <div class="w-1/2">
    <label for="language" class="block mb-2">Select Language</label>
    <p-select
      inputId="language"
      [options]="availableLanguages"
      [(ngModel)]="selectedLanguageCode"
      optionLabel="name"
      optionValue="code"
      placeholder="Select a Language"
      [filter]="true"
      class="w-full">
    </p-select>
  </div>

  <div class="w-1/2">
    <label for="voice" class="block mb-2">Select Voice</label>
    <p-select
      inputId="voice"
      [options]="voices"
      [(ngModel)]="selectedVoiceId"
      optionLabel="name"
      optionValue="id"
      placeholder="Select a Voice"
      [filter]="true"
      class="w-full">
    </p-select>
  </div>
</div>

<div class="mt-4">
  <a href="https://cloud.google.com/text-to-speech/docs/chirp3-hd" target="_blank">Check Google Voice Examples</a>
</div>

<div class="p-dialog-footer">
  <p-button label="Cancel" icon="pi pi-times" (click)="cancel()" styleClass="p-button-text"></p-button>
  <p-button label="Select" icon="pi pi-check" (click)="selectVoice()" [disabled]="!selectedVoiceId() || !selectedLanguageCode()"></p-button>
</div>
